import { DEFAULT_LANGUAGE } from "@montana/constants/defaults";
import { normalizeLanguageId } from "@montana/helpers/market.helper";
import { IDynamicSettings } from "@montana/models/app-settings";
import { Reducer } from "redux";
import { IDynamicSettingsContainerState } from "./dynamic-settings";
import { DynamicSettingsAction, IDynamicSettingsInitAction} from "./dynamic-settings.actions";

const setAppSettingsLanguage = (settings: Omit<IDynamicSettings, "language">, activeLanguage?: string): IDynamicSettings => {
    const selectedLanguage = settings.languages?.find(language => language.isSelected);
    return {
        ...settings,
        language: normalizeLanguageId(activeLanguage) || selectedLanguage?.languageURLSegment || DEFAULT_LANGUAGE,
    };
};

/*const transformAppSettingsLinks = (settings: IDynamicSettings): IDynamicSettings => {
    const links = settings.links;
    const language = settings.languages?.find(lang => lang.isSelected)?.languageURLSegment;
    if (links && language) {
        Object.keys(links).forEach(key => {
            // eslint-disable-next-line
            (links as any)[key] = transformUrlToLanguage(settings.languages, (links as any)[key], language);
        });
    }
    return {...settings, links};
};*/

export const dynamicSettingsReducer: Reducer<IDynamicSettingsContainerState, IDynamicSettingsInitAction> = (state = {} as IDynamicSettingsContainerState, action) => {
    switch (action.type) {
        case DynamicSettingsAction.INIT: {
            if (!action.settings) {
                return state;
            }

            //Todo: Change the name of the cfCountryHeader to cfMarketHeader
            const { settings, cfCountryHeader } = action;

            return setAppSettingsLanguage({
                ...settings,
                cfCountry: cfCountryHeader
            }, action.activeLanguage);
        }
        default: {
            return state;
        }
    }
};
